import { Box, SxProps } from '@mui/material';
import * as React from 'react';
import { FunctionComponent } from 'react';
import TextContent from './TextContent';
import ResponsiveSplitSection from '../common/ResponsiveSplitSection';
import { useResponsive } from '../../contexts/ResponsiveContext';
import { AboutSustainabilityEnvironmentalContent } from '../../graphql/pimcore/modules/siteContent/types/AboutSustainabilityContent';
import { NEW_CS_BASE_URL } from '../../utils/ProjectUrls';
import SustainabilityContainer from './SustainabilityContainer';
import EnvironmentalTab from './EnvironmentalTab';

interface EnvironmentalPageProps {
    cmsContent: AboutSustainabilityEnvironmentalContent;
}

const EnvironmentalPage: FunctionComponent<EnvironmentalPageProps> = ({ cmsContent }) => {
    const { isScreenXs } = useResponsive();
    const environmentalButtonProps: SxProps = {
        padding: isScreenXs ? '2px 11px' : '4px 11px',
        gap: '10px',
        backgroundColor: '#E5673E',
        borderRadius: '5px',
        fontFamily: 'Poppins',
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: isScreenXs ? '16px' : '24px',
        lineHeight: '36px',
        whiteSpace: 'nowrap',
        textTransform: 'none',
        transition: 'none',
        color: 'white',
        '&:hover': {
            background: 'linear-gradient(0deg, #B75332 0%, #E5673E 100%)',
        },
    };
    const textContent = (
        <Box sx={{ marginTop: '1rem' }}>
            <TextContent
                name={'social'}
                content1={<div dangerouslySetInnerHTML={{ __html: cmsContent.mainText.content }} />}
            />
        </Box>
    );
    return (
        <>
            <ResponsiveSplitSection
                textContent={textContent}
                backgroundColor={'white'}
                smallScreenTextFirst={false}
                imageSrc={cmsContent.mainImage.imageUrl}
                bigScreenAlignItem="flex-start"
                buttonText={cmsContent.link.linkText}
                buttonSx={environmentalButtonProps}
                buttonHref={NEW_CS_BASE_URL + cmsContent.link.linkRoute}
            />
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    padding: '0',
                    width: '100%',
                    boxSizing: 'border-box',
                    flexDirection: 'column',
                    overflowY: 'hidden',
                    backgroundColor: '#F8F8F8',
                }}
            >
                <SustainabilityContainer backgroundColor={'#F8F8F8'}>
                    <EnvironmentalTab cmsContent={cmsContent} />
                </SustainabilityContainer>
            </Box>
        </>
    );
};

export default EnvironmentalPage;
